import script from "./PatCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatCard.vue?vue&type=script&setup=true&lang=ts"

import "./PatCard.vue?vue&type=style&index=0&id=17349fdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17349fdc"]])

export default __exports__